<div class="p-8">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="lab-mng">
        Manage User Permissions
    </div>
    <div class="box">
        <div class="relative w-full btn-1 my-6 items-center flex">
            <label class="flex absolute inset-y-0 items-center pl-3 pointer-events-none">
                <svg aria-hidden="true" class="w-5 text-gray-500 dark:text-gray-400" fill="currentColor"
                    viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z"
                        stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </svg>
            </label>
            <input type="text" id="simple-search" class="br-1 btn-1 pt-4 border-gray-200 org-name block p-4"
                placeholder="Search by Username/Permission" style="padding-left: 45px; width: 32%;"  (keyup)="applyFilter($event)" [formControl]="searchControl">
        </div>

        <div class="my-6 mr-2">
            <select name="labNames" id="" class="btn-2 border-gray-200 rounded-lg org-name"
            (change)="onChange($event)" [(ngModel)]="selectedOrg">
            <option value="" class="org-name">All Organizations</option>
            <ng-container *ngFor="let org of orgList">
            <option class="input-style" [value]="org.orgId">{{org.orgName}}</option>
                </ng-container>
            </select>
        </div>
        
        <div class="my-6 text-right" *ngIf="userPermissions.includes('create_permission')">
            <button (click)="addUserPermissions()" class="btn-3 bg-greenish-blue text-white p-2 rounded-lg shadow-xl hover:bg-red-600">
                Add Permissions
            </button>
        </div>
    </div>
    <div  class="min-h-screen flex">
        <div class="overflow-x-auto w-full">
            <div class="min-w-screen min-h-screen table-wrapper flex justify-center font-sans">
                <div class="w-full">
                    <div class="bg-white shadow-md rounded my-6">
                        <table
                            class="mx-auto max-w-full w-full whitespace-nowrap bg-white divide-y divide-gray-300 overflow-hidden">
                            <thead class="bg-greenish-blue text-white">
                                <tr class="text-white-600 uppercase text-sm leading-normal">
                                    <th class="text-left font-semibold text-sm uppercase px-4 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>User Name</span>
                                        </div>
                                    </th>
                                    <th class="text-left font-semibold text-sm uppercase px-4 py-4">
                                        <div class="flex inline-flex items-center">
                                            <span>Organization</span>
                                        </div>
                                    </th>
                                    <th class="px-6 py-4 text-center permission-td">
                                        <div class="flex">
                                            <span>Permissions</span>
                                        </div>
                                    </th>
                                    <th class="text-center" *ngIf="userPermissions.includes('edit_permission')">
                                        <div class="flex inline-flex items-center">
                                            <span>Type</span>
                                        </div>
                                    </th>
                                    <th class="text-center" *ngIf="userPermissions.includes('edit_permission')">
                                        <div class="flex inline-flex items-center">
                                            <span>Action</span>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="text-gray-600 text-sm font-light">
                                <tr class="border-b border-gray-200 hover:bg-gray-100" *ngFor="let item of permissions" >
                                    <td class="px-6 py-4 text-left">
                                        <div class="flex items-center">
                                            <span class="user-text">{{item.user_id}}</span>
                                        </div>
                                    </td>
                                    
                                    <td class="px-6 py-4 text-left">
                                        <div class="flex items-center">
                                            <span class="user-text">{{item.organization_name}}</span>
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 text-left permission-td">
                                        <div class="flex items-center permissions" [attr.title]="item.permissions?.join(', ') || ''">
                                            <ng-container *ngIf="item.permissions?.length > 10">
                                                <span class="permissions-text">
                                                    {{ item.permissions.slice(0, 10).join(', ') }}...
                                                </span>
                                            </ng-container>
                                            <ng-container *ngIf="item.permissions?.length <= 10">
                                                <span class="permissions-text">{{ item.permissions?.join(', ') || '' }}</span>
                                            </ng-container>
                                        </div>
                                    </td> 
                                    <td class="text-center" *ngIf="userPermissions.includes('edit_permission')">
                                        <div class="flex inline-flex items-center">
                                            <span class="user-text">{{item.permission_type}}</span>
                                        </div>
                                    </td>                                    
                                    <td class="px-6 py-4 text-center action" *ngIf="userPermissions.includes('edit_permission')">
                                        <button (click)="updateUserPermissions(item)">
                                            <img src="../../../../assets/img/icons/edit.svg" alt="Edit" title="Update User Permission">
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> 
                </div> 
            </div> 
        </div>
    </div>
 </div>
